module.exports = __webpack_public_path__ + "img/ctrl-u-stub-up-1.cfc02708.svg";